"use strict";
// @ts-ignore
try {
    self['workbox:window:5.1.3'] && _();
}
catch (e) { }
